// UI
import { Button } from "@/components/Button"
import { DialogWrapper } from "@/components/dialogs/DialogWrapper"

// Icons
import { XIcon } from "@/lib/icons"

// Translations
import { useTrans } from "@/lib/i18n"

/**
 * ProjectTypeSolarFundsInfo
 * @returns
 */
export function ProjectTypeSolarFundsInfo({
	onClose,
}: {
	onClose: () => void
}) {
	const t = useTrans("dashboard")

	const EXTERNAL_URL_SOLARFUNDS_INFO =
		"https://informatie.zonhub.com/support/solutions/articles/17000096945-wat-is-het-zonfonds"

	return (
		<DialogWrapper>
			<div className="flex items-start justify-between rounded-t border-b p-5 dark:border-gray-600">
				<h3 className="text-xl font-semibold text-gray-900 lg:text-2xl dark:text-white">
					{t("dashboard:project_type_dialog.solar_funds.title")}
				</h3>
				<button
					onClick={() => onClose()}
					type="button"
					className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
					data-modal-toggle="default-modal"
				>
					<XIcon width={24} className="text-2xl text-gray-400" />
				</button>
			</div>

			<div className="space-y-6 p-6">
				<p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
					{t("dashboard:project_type_dialog.solar_funds.description")}
				</p>
			</div>

			<div className="flex flex-col items-center space-x-2 rounded-b border-t border-gray-200 p-6 dark:border-gray-600">
				<Button
					onClick={() =>
						(window.location.href = EXTERNAL_URL_SOLARFUNDS_INFO)
					}
				>
					{t("dashboard:project_type_dialog.solar_funds.cta")}
				</Button>
			</div>
		</DialogWrapper>
	)
}
